import React from 'react';
import PropTypes from 'prop-types';
import { InputCheckbox } from '@sm360/widget-commons-forms';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

const BrandList = ({ make, handleMakeSelection }) => {
    const label = make.count > 0 ? `${make.label} (${make.count})` : make.label;
    return (
        <div className="listing-used-brand">
            <InputCheckbox
                label={label}
                value={make.code}
                valueChange={() => handleMakeSelection(make.code)}
                isSelected={make.isSelected}
                classNames={['brand']}
            />
        </div>
    );
};

BrandList.propTypes = {
    make: PropTypes.instanceOf(MetaDataModel).isRequired,
    handleMakeSelection: PropTypes.func.isRequired,
};

BrandList.displayName = 'BrandList';

export default BrandList;
